var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logistics"},[_c('el-timeline',[_c('el-timeline-item',[_vm._v(" 物流公司："+_vm._s(_vm.order.express.express_name)+" ")]),_c('el-timeline-item',[_vm._v(" 物流单号："+_vm._s(_vm.order.express_no)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }